require('./bootstrap');

$(function() {

    var mobileNav = false;

    function solidNav(){
        if ($(window).scrollTop() >= 50) {
            $('nav').addClass('fixed');
            $('.epv-cta').addClass('hide');
        } else {
            $('nav').removeClass('fixed');
            $('.epv-cta').removeClass('hide');
        }
    }
    $(window).scroll(function () {
        solidNav();
    });

    $(window).scroll(function() {
        if($(window).scrollTop() + $(window).height() > $(document).height() - 150) {
            $('.truman-head-wrapper').fadeOut(200);
        }else{
            $('.truman-head-wrapper').fadeIn(200);
        }
     });

    // $('.burger').click(function() {
    //     if(!mobileNav){
    //         $('#nav-toggle').addClass('active');
    //         $('body').addClass('mobileNav');
    //         $('nav').addClass('active');
    //         mobileNav = true;
    //     }else{
    //         $('#nav-toggle').removeClass('active');
    //         $('body').removeClass('mobileNav');
    //         $('nav').removeClass('active');
    //         mobileNav = false;
    //     }
    // });
    solidNav();

    // $('.hitbox').hover(function() {
    //     $('.tooltip-content').fadeIn();
    //   }, function() {
    //     $('.tooltip-content').fadeOut();
    //   });

    // $('.truman-tooltip.factory').css({
    //     'top' : $('#welcome-to-the-factory video').outerHeight() - 10 + 'px'
    // });
    var rellax = new Rellax('.rellax');

    $('.store').hover(function() {
        id = $(this).data('id');
        $('#map').find('.marker'+id).prop('src',window.location.origin+'/images/elements/truman-head-pin-active.png');
      }, function() {
        id = $(this).data('id');
        $('#map').find('.marker'+id).prop('src',window.location.origin+'/images/elements/truman-head-pin.png');
      });

      $('.truman-head').hover(
        function() {
            $('.quote-wrapper').stop().fadeIn();
        }, function() {
            $('.quote-wrapper').stop().fadeOut();
        }
      );

      $('.mobile-toggle').click(function() {
        if(!mobileNav){
            $('body').addClass('fixed');
            $('header').addClass('mobile');
            mobileNav = true;
        }else{
            $('body').removeClass('fixed');
            $('header').removeClass('mobile');
            mobileNav = false;
        }
    });

});

// var rellax = new Rellax('.rellax');

